import { render } from "./table_create_drawer_project.vue?vue&type=template&id=4717d074&scoped=true"
import script from "./table_create_drawer_project.vue?vue&type=script&lang=js"
export * from "./table_create_drawer_project.vue?vue&type=script&lang=js"

import "./table_create_drawer_project.vue?vue&type=style&index=0&id=4717d074&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4717d074"]])

export default __exports__